import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class UsersHttp {
  constructor(protected httpService: HttpService) {}

  loadUsers = async () => await this.httpService.get('/customers?search=&skip=0');
  // search users
  filteredUserList = async (listQuery) =>
    this.httpService.get(
      `/customers?search= + ${listQuery.filterValues.searchUsers}&role=${listQuery.filterValues.role}&page=${listQuery.page}&size=${
        listQuery.size
      }${(listQuery.sortField && '&sort=' + listQuery.sortField) || ''}`
    );
  filteredUserListCount = async (listQuery) =>
    this.httpService.get(`/customers/count?search=${listQuery.filterValues.searchUsers}&role=${listQuery.filterValues.role}`);
  activeDeactiveUser = async (userStatus, id) => await this.httpService.post(`/admin/activate-user?activate=${userStatus}&userId=${id}`);
  resetUserPassword = async (id) => await this.httpService.post(`/admin/reset-user-password?userId=${id}`);
  unBlockUser = async (userId) => this.httpService.put(`/customers/unblock-user?userId=${userId}`);
}

@Injectable()
export class UsersService {
  constructor(protected http: UsersHttp) {}

  async loadUsers() {
    return await this.http.loadUsers();
    // return [
    //   { id: '2', status: true, firstName: 'nilu' },
    //   { id: '1', status: false, firstName: 'ABC' }
    // ];
  }
  async filteredUserList(listQuery) {
    return await this.http.filteredUserList(listQuery);
  }
  async filteredUserListCount(listQuery) {
    return await this.http.filteredUserListCount(listQuery);
  }
  async activeDeactiveUser(userStatus, id) {
    return await this.http.activeDeactiveUser(userStatus, id);
  }
  async resetUserPassword(id) {
    return await this.http.resetUserPassword(id);
  }
  async unBlockUser(id) {
    return await this.http.unBlockUser(id);
  }
}
